// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1jB2u","label":"LabeledBox_label__qsWH4"};